import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgApi = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "api-icon",
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .secc2 {\n        fill: #0573A9;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "secc2",
			d: "M7,4.47772l1.2002,1.2002,2.17676-2.17773L7,.12225l-3.37793,3.37793,2.17773,2.17773,1.2002-1.2002ZM7,1.67792l1.82227,1.82227-.62207.62207-1.2002-1.2002-1.2002,1.2002-.62207-.62207,1.82227-1.82227Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "secc2",
			d: "M10.59961,3.62225l-2.17676,2.17773,1.19922,1.2002-1.19922,1.19971,2.17676,2.17725,3.37891-3.37695-3.37891-3.37793ZM9.97754,8.19989l1.20117-1.19971-1.20117-1.2002.62207-.62207,1.82227,1.82227-1.82227,1.82178-.62207-.62207Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "secc2",
			d: "M4.47803,7.00018l1.19971-1.2002-2.17773-2.17773L.12207,7.00018l3.37793,3.37695,2.17773-2.17725-1.19971-1.19971ZM4.12207,8.19989l-.62207.62207-1.82227-1.82178,1.82227-1.82227.62207.62207-1.19971,1.2002,1.19971,1.19971Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "secc2",
			d: "M7,9.62225l-1.2002-1.19971-2.17773,2.17725,3.37793,3.37891,3.37695-3.37891-2.17676-2.17725-1.2002,1.19971ZM7,12.42206l-1.82227-1.82227.62207-.62207,1.2002,1.19922,1.2002-1.19922.62207.62207-1.82227,1.82227Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "secc2",
			d: "M5.12207,7.00018l1.87793,1.87744,1.87695-1.87744-1.87695-1.87793-1.87793,1.87793ZM7,7.32196l-.32227-.32178.32227-.32227.32178.32227-.32178.32178Z"
		})
	]
});
export default SvgApi;
